function emitCustomEvent(target, event, detail) {
  const instance = new CustomEvent(event, {
    detail,
    bubbles: true,
    composed: true,
    cancelable: true
  });
  target?.dispatchEvent(instance);
}
export {
  emitCustomEvent
};
//# sourceMappingURL=definitions.js.map
